export default __webpack_public_path__ + "static/media/movie.ce69c03c.PNG";